import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Select, Divider, Drawer,
  Tooltip,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import FormCustomStatus from '../../Admin/AdminConfiguration/CustomStatus/FormCustomStatus';
import './style.scss';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const SelectStatus = ({
  onChange, selectedCustomStatus, disabled, showError, containerClass, inputClassName, showAddStatus, getPopupContainer, customStyle, dropdownAlign, posibleStatuses, entityName, dropdownStyle,
}) => {
  const [showCreateStatusDrawer, setShowCreateStatusDrawer] = useState(false);
  const [call, setCall] = useState(false);

  const statusLength = posibleStatuses
    ?.filter((item) => (!disabled ? !['VOID', 'SENT_FOR_APPROVAL'].includes(item?.type) : true))?.length;

  return (
    <Fragment>
      <div className="select-custom-status__wrapper">
        <PRZSelect
          value={selectedCustomStatus}
          filterOption={false}
          getPopupContainer={getPopupContainer ? (triggerNode) => triggerNode.parentNode : false}
          placeholder="Select status.."
          disabled={disabled || statusLength === 1}
          onChange={(value) => onChange(posibleStatuses?.filter((status) => status?.custom_status_id === value)[0])}
          style={customStyle || {
            border: '1px solid rgba(68, 130, 218, 0.2)',
            height: '28px',
            width: '100%',
            fontSize: '11px',
          }}
          dropdownAlign={dropdownAlign}
          suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
          bordered={false}
          showError={showError}
          errorName="*Please select a status"
          errorClassName="input-error"
        >
          {posibleStatuses
            ?.filter((item) => (!disabled ? !['VOID', 'SENT_FOR_APPROVAL'].includes(item?.type) : true))
            ?.map((item) => (
              <Option key={item?.custom_status_id} value={item?.custom_status_id}>
                <Tooltip title={item?.status_name}>
                  <div className="select-custom-status__option">
                    {`${item?.status_name?.replaceAll('_', ' ')}`}
                  </div>
                </Tooltip>
              </Option>
            ))}
        </PRZSelect>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ CustomStatusReducers, UserReducers }) => ({
  user: UserReducers.user,
  customStatusSalesOrder: CustomStatusReducers.customStatusSalesOrder,
  customStatusInvoice: CustomStatusReducers.customStatusInvoice,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
});

SelectStatus.propTypes = {
  user: PropTypes.any,
  getCustomStatus: PropTypes.func,
  customStatusSalesOrder: PropTypes.any,
  customStatusInvoice: PropTypes.any,
  selectedCustomStatus: PropTypes.any,
  showAddStatus: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClass: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  getPopupContainer: PropTypes.bool,
  customStyle: PropTypes.any,
  dropdownAlign: PropTypes.any,
  notRequired: PropTypes.bool,
  tenantId: PropTypes.any,
  entityName: PropTypes.any,
  posibleStatuses: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectStatus));
